import { getTableColumn, TableColumn } from '@shared/UI';
import { ITradeBreak } from './interfaces';

export const getTradeBreaksTableColumns = (): TableColumn<ITradeBreak>[] => {
    return [
        getTableColumn({
            dataField: 'EodId',
            headerFormatter: () => 'OMS ID',
            className: (cell, row) => {
                const hasEquals = cell === row.EvId;
                return hasEquals ? 'correct' : 'incorrect';
            },
        }),
        getTableColumn({
            dataField: 'EvId',
            headerFormatter: () => 'Execution Venue ID',
            className: (cell, row) => {
                const hasEquals = cell === row.EodId;
                return hasEquals ? 'correct' : 'incorrect';
            },
        }),
        getTableColumn({
            dataField: 'EodQty',
            headerFormatter: () => 'OMS Quantity',
            className: (cell, row) => {
                const hasEquals = cell === row.EvQty;
                return hasEquals ? 'correct' : 'incorrect';
            },
        }),
        getTableColumn({
            dataField: 'EvQty',
            headerFormatter: () => 'Execution Venue Quantity',
            className: (cell, row) => {
                const hasEquals = cell === row.EodQty;
                return hasEquals ? 'correct' : 'incorrect';
            },
        }),
        getTableColumn({
            dataField: 'EodPx',
            headerFormatter: () => 'OMS Price',
            className: (cell, row) => {
                const hasEquals = cell === row.EvPx;
                return hasEquals ? 'correct' : 'incorrect';
            },
        }),
        getTableColumn({
            dataField: 'EvPx',
            headerFormatter: () => 'Execution Venue Price',
            className: (cell, row) => {
                const hasEquals = cell === row.EodPx;
                return hasEquals ? 'correct' : 'incorrect';
            },
        }),
    ];
};
